import React from "react"
import { Button } from "../helpers"

const AddressCard = (props) => {
    
    const { id, address, city, stateName, buttonLabel, handleAddressSelection, gstinCode, className, disabled, pinCode, gstinTradeName, waterMark, ledgerName, showLedgerName, readOnly} = props

    return(
        <div className='shipping-component'>
            <div className={`shipping-address ${waterMark ? waterMark : ''}`}> 
                <div className='shipping-address-item align-items-stretch'>
                    <div className='shipping-address-card-details'>
                        {gstinTradeName && <h4 className="m-0 mb-2">{gstinTradeName}</h4>}
                        <div className='shipping-address-card-text1'>{address},{pinCode}</div>
                        <div className='shipping-address-card-city mt-2'>
                            {gstinCode && <p className="my-1">{gstinCode}</p>}
                            <p className="my-1">{city}</p>
                            <p className="my-1">{stateName}</p>
                        </div>
                        {
                            showLedgerName && ledgerName ?
                                <div className=''><span style={{fontWeight:600, color:'#495057'}}>Ledger Name:</span> {ledgerName} </div>
                                : null
                        }
                    </div>
                    { !readOnly && <Button className={className}  label={buttonLabel} onClick={() => handleAddressSelection(id)} disabled={disabled}/> }
                </div>
            </div>  
        </div>
    )
}

export default AddressCard